import { Blockquote } from '@tiptap/extension-blockquote'
import { Bold } from '@tiptap/extension-bold'
import { Code } from '@tiptap/extension-code'
import { CodeBlock } from '@tiptap/extension-code-block'
import { Document } from '@tiptap/extension-document'
import { HardBreak } from '@tiptap/extension-hard-break'
import { Heading } from '@tiptap/extension-heading'
import { HorizontalRule } from '@tiptap/extension-horizontal-rule'
import { Italic } from '@tiptap/extension-italic'
import { BulletList, ListItem, ListKeymap, OrderedList } from '@tiptap/extension-list'
import { Paragraph } from '@tiptap/extension-paragraph'
import { Strike } from '@tiptap/extension-strike'
import { Text } from '@tiptap/extension-text'
import { Underline } from '@tiptap/extension-underline'
import { Dropcursor } from '@tiptap/extensions/drop-cursor'
import { TrailingNode } from '@tiptap/extensions/trailing-node'
import { UndoRedo } from '@tiptap/extensions/undo-redo'

export function tiptapStarterExtensions () {
  return [
    Bold,
    Blockquote,
    BulletList,
    Code,
    CodeBlock,
    Document,
    Dropcursor,
    HardBreak,
    Heading,
    UndoRedo,
    HorizontalRule,
    Italic,
    ListItem,
    ListKeymap,
    OrderedList,
    Paragraph,
    Strike,
    Text,
    Underline,
    TrailingNode,
  ]
}
